export default "__VITE_ASSET__CHE9Dckx__"